import stbAPIGateway from '../../../../services/stbAPIGateway';

export const patchCsvZipHubUpload = async (
  { rootGetters },
  { clientSid, batchId, email, selectedCsvTypes }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const client = await stbApi.patchCsvZipHubUpload({}, clientSid, batchId, email, selectedCsvTypes);
  return client;
};
